export const LogoutWait = "Logging Out, It May Take A While !";
export const LoggedOut = "Logged Out !";
